import { Search, Collapse, CollapseItem, Cell ,Toast } from 'vant'
import { mapState } from 'vuex'
import { localget, localset, localremove} from 'Utils/storage.js'
import { changeBlur ,changefocus } from 'Utils/tools'
import ldStatusbar from 'Common/ldStatusbar'
import { getRelativeDate,getStrDate } from 'Utils/dateUtil'

export default {
  // name: 'HtSearch',
  components: {
    [Search.name]: Search,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    Toast,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldNavbar: () => import('Common/ldNavbar'),
    City: () => import('Common/city'),
    ldStatusbar
  },
  data() {
    return {
      down: { use: false },
      pageCtrl: {}, // 页面控制信息
      items: [],
      findGeo: [],
      getProductName: {
        //产品名称转换
        commericalLocations: {
          name: '商圈',
          icon: 'iconxiaofeiquan1'
        },
        districts: {
          name: '行政区',
          icon: 'icongongsidizhi'
        },
        landmarkLocations: {
          name: '地标',
          icon: 'icondibiao'
        }
      },
      historicalRecord: [],
      carHistory: [],
      list: [],
      orderHistoryList:[], // 用车历史订单使用过的地址
      showHistoryList:[] // 筛选过后 用车历史订单使用过的地址
    }
  },
  props: {
    isCar: {
      //用车
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '关键词/位置/品牌/酒店名'
    },
    cityId: {
      type: String,
      default: ''
    },
    cityName: {
      type: String,
      default: ''
    },
    carType:{
      type: Number,
      default: ''
    },
    jcZdCode:{ //城市三字码
      type: String,
      default:''
    }
  },
  computed: mapState({
    userInfo: state => state.app.userInfo,
    model: state => state.ht.htSearchInfo,
    interfacePlat: state => state.ht.interfacePlat
  }),
  mounted() {
    if (this.model._international == 0) this.init()
    let _historicalRecord = localget('_historicalRecord')
    this.model._keywords = ''
    for (let i in _historicalRecord) {
      if (this.model._international + '_' + this.userInfo.empInfo.empId == i) {
        this.historicalRecord = _historicalRecord[i] || [] // 获取历史记录
      }
    }
  },
  activated() {
    if (this.isCar) {
      let _historyLog = localget('_historyLog')
      if (_historyLog && _historyLog.car && _historyLog.car.site) {
        this.carHistory = this.showHistoryList
      }
      this.model._keywords = ''
    }
  },
  methods: {
    changeBlur,
    changefocus,
    async init() {
      this.carHistory = []
      this.showHistoryList = []
      this.orderHistoryList = []
      if (this.isCar) {
        var orderParams = {
          "count": 100,
          "dateEnd": getStrDate(),
          "dateStart": getRelativeDate(-365),
          "findType": "1",
          "pageNum": 1,
        }
        await this.$api['common/allOrderList'](orderParams).then(res => {
          let cache = res.data.list || []
          var newProductType = 0
          cache.forEach(item=>{
            //item.productType  1日包 2半日包  3点对点  4接机  5送机  6接站 7送站 8即时 9预约
            if(item.productType == 4) { newProductType = 0 }
            else if(item.productType == 5) { newProductType = 1 }
            else if(item.productType == 6) { newProductType = 2 }
            else if(item.productType == 7) { newProductType = 3 }
            else if(item.productType == 1 || item.productType == 2) { newProductType = 4 }
            else if(item.productType == 8 || item.productType == 9) { newProductType = 5 }
            if((item.cplx == '10906') && item.voyageZh){
              if(this.carType == 0 || this.carType == 2 || this.carType == 5){
                this.orderHistoryList.push({type : newProductType, location: item.xcdd,city: item.voyageZh})
              } else if(this.carType == 1 || this.carType == 3 || this.carType == 4){
                this.orderHistoryList.push({type : newProductType, location: item.scdd,city: item.voyageZh})
              }
              this.orderHistoryList = Array.from(new Set(this.orderHistoryList.map(JSON.stringify))).map(JSON.parse)
            }
          })
        })
        if(this.orderHistoryList){
          for( let i in this.orderHistoryList){
            if(this.orderHistoryList[i].type == this.carType){
              this.showHistoryList.push(this.orderHistoryList[i])
              this.carHistory = this.showHistoryList
              if(this.carHistory.length == 5){
                break
              }
            }
          }
        } else{
          this.$api['baidu/baiduPlace']({
            cityName: this.cityName || this.model._city,
            keywords: this.cityName
          }).then(res => {
            let cache = res.data || {}
            let list = cache.list || []
            if (list && list.length > 0) {
              list.splice(0, 1)
            }
            this.list = list
          })
        }

      } else {
        // 获取行政区、商圈数据
        this.$api['htQuery/findGeoByCityId']({
          cityId: this.cityId || this.model.cityId,
          interfacePlatId: this.interfacePlat.platZhid
        }).then(res => {
          this.findGeo = []
          for (var i in res.data) {
            this.findGeo.push({
              list: res.data[i],
              name: this.getProductName[i].name,
              icon: this.getProductName[i].icon,
              checked: false
            })
          }
        })
      }
    },
    initData() {
      //* 初始化model值
      this.model.businessZone = ''
      this.model.businessZoneName = ''
      this.model.district = ''
      this.model.districtName = ''
      this.model.lat = ''
      this.model.lon = ''
      this.model.brandIds = ''
      this.model._keywords = ''
      this.model.keywords = ''
    },
    baiduSelect (val){
      this.$api['baidu/baiduPlace'](val).then(res => {
        let cache = res.data || {}
        let list = cache.list || []
        if (list && list.length > 0) {
          list.splice(0, 1)
        }
        this.list = list
      })
    },
    selectItem(item) {
      //点击行政区、商圈、地标
      if (this.isCar) {
        //用车
        let _historyLog = localget('_historyLog')
        if (!_historyLog) {
          _historyLog = {}
        }
        if (!_historyLog.car) {
          _historyLog.car = {}
        }
        if (item.name) {
          this.searchQueryText(item.name).then(el => {
            if (el.list && el.list.length > 0) {
              el.list[0].siteCityId = this.cityId || this.model._cityId
              el.list[0].siteCityName = this.cityName || this.model._city
              this.$emit('selected', el.list[0])
              if (_historyLog.car.site) {
                if (_historyLog.car.site.length >= 5) {
                  _historyLog.car.site.shift()
                }
                let bool = _historyLog.car.site.some(el => {
                  return el.name == el.list[0].name
                })
                if (bool) {
                } else {
                  _historyLog.car.site.unshift(el.list[0])
                }
              } else {
                _historyLog.car.site = [el.list[0]]
              }
              localset('_historyLog', _historyLog)
              this.back()
            } else {
              this.$toast('无效数据')
              return
            }
          })
        } else {
          item.siteCityId = this.cityId || this.model._cityId
          item.siteCityName = this.cityName || this.model._city
          this.$emit('selected', item)
          if (_historyLog.car.site) {
            if (_historyLog.car.site.length >= 5) {
              _historyLog.car.site.shift()
            }
            let bool = _historyLog.car.site.some(el => {
              return el.name == item.name
            })
            if (bool) {
            } else {
              _historyLog.car.site.unshift(item)
              this.carHistory.unshift(item)
            }
          } else {
            _historyLog.car.site = [item]
          }
          localset('_historyLog', _historyLog)
          this.back()
        }
        return
      }
      let isPush = true
      item['mode'] = 1
      this.historicalRecord.forEach(element => {
        if (element.mode == '1' && element.geoId == item.geoId) {
          isPush = false
        }
      })
      if (isPush) this.historicalRecord.push(item)
      /**
             * 历史记录最多为5条
             */
      if (this.historicalRecord.length > 5) {
        this.historicalRecord.shift()
      }
      // this.$store.commit('ht/historicalRecord', this.historicalRecord)
      let historicalRecord = localget('_historicalRecord') || {}
      historicalRecord[
        this.model._international + '_' + this.userInfo.empInfo.empId
      ] = this.historicalRecord.reverse()
      localset('_historicalRecord', historicalRecord)
      this.initData()

      if (item.type == 1) {
        //商圈
        this.model.searchType = 2
        this.model.businessZone = item.geoId
        this.model.businessZoneName = item.geoName
      } else if (item.type == 2) {
        //行政区
        this.model.searchType = 1
        this.model.district = item.geoId
        this.model.districtName = item.geoName
      } else if (item.type == 3) {
        //地标
        this.model.searchType = 3
        // 下面的keywords暂时不传
        this.model.keywords = item.geoName
        // item.geoName &&
        //         this.searchQueryText(item.geoName).then(el => {
        //         	this.model.lat = el[0].lat
        //         	this.model.lon = el[0].lng
        //         	this.model._keywords = item.geoName
        //         	this.back()
        //         })
      }
      // _keywords 该值用于回显，若清除该值，将清除商圈、行政区、地标关联值
      if (item.type == 1 || item.type == 2 || item.type == 3) {
        this.model._keywords = item.geoName
        this.back()
      }
    },
    searchItem(item) {
      this.model._hotelId = item.hotelId ? item.hotelId : '';
      //通过搜索方式
      if (this.isCar) {
        item.siteCityId = item.siteCityId || this.cityId || this.model._cityId
        item.siteCityName = item.siteCityName || this.cityName || this.model._city
        let para={
          cityId:this.cityId,
          jcZdCode:this.jcZdCode
        }
        this.$emit('selected', item,para) //用车
        let _historyLog = localget('_historyLog')
        if (!_historyLog || _historyLog=='undefined') {
          _historyLog = {}
        }
        if (!_historyLog.car) {
          _historyLog.car = {}
        }
        if (_historyLog.car.site) {
          let bool = _historyLog.car.site.some(el => {
            return el.name == item.name
          })

          if (bool) {
          } else {
            _historyLog.car.site.unshift(item)
          }

          if (_historyLog.car.site.length > 5) {
            _historyLog.car.site.pop()
          }
        } else {
          _historyLog.car.site = [item]
        }
        localset('_historyLog', _historyLog)
        this.back()
        return
      }
      let isPush = true
      item['mode'] = 2
      this.historicalRecord.forEach(element => {
        if (element.mode == '2' && element.filterId == item.filterId) {
          isPush = false
        }
      })
      if (isPush) this.historicalRecord.push(item)

      /**
             * 历史记录最多为5条
             */
      if (this.historicalRecord.length > 5) {
        this.historicalRecord.shift()
      }

      // this.$store.commit('ht/historicalRecord', this.historicalRecord)
      let historicalRecord = localget('_historicalRecord') || {}
      historicalRecord[
        this.model._international + '_' + this.userInfo.empInfo.empId
      ] = this.historicalRecord.reverse()
      localset('_historicalRecord', historicalRecord)
      this.initData()
      /**
             * 酒店
             */
      if (item.type == '0') {
        this.model.searchType = 0
        if(item.lat && item.lng){
          this.model.lat = item.lat
          this.model.lon = item.lng
        } else {
          this.model.keywords = item.name
        }
      }
      /**
             * 地标
             */
      if (
        item.type == '6' ||
                item.type == '8' ||
                item.type == '9' ||
                item.type == '10' ||
                item.type == '11' ||
                item.type == '12' ||
                item.type == '14'
      ) {
        this.model.searchType = 3
        this.model.lat = item.lat
        this.model.lon = item.lng
      }
      /**
             * 行政区
             */
      if (item.type == '4') {
        this.model.searchType = 1
        this.model.district = item.filterId
        this.model.districtName = item.name
      }
      /**
             * 商业区
             */
      if (item.type == '5') {
        this.model.searchType = 2
        this.model.businessZone = item.filterId
        this.model.businessZoneName = item.name
      }
      /**
             * 品牌
             */
      if (item.type == '3') {
        this.model.searchType = 0
        this.model.brandIds = item.filterId
      }
      this.model._keywords = item.name
      this.back()
    },
    historicalRecordItem(item) {
      if (item.mode == '1') {
        this.selectItem(item)
      } else if (item.mode == '2') {
        this.searchItem(item)
      } else {
        this.$api['baidu/baiduPlace']({
          cityName: item.city,
          keywords: item.location
        }).then(res => {
          let cache = res.data || {}
          let list = cache.list || []
          for(let i in list){
            var _historyLog = localget('_historyLog')
            if (!_historyLog) {
              _historyLog = {}
            }
            if (!_historyLog.car) {
              _historyLog.car = {}
            }
            if (_historyLog.car.site) {
              if (_historyLog.car.site.length > 5) {
                _historyLog.car.site.shift()
              }
              let bool = _historyLog.car.site.some(el => {
                return el.name == list[i].name
              })
              if (bool) {
              } else {
                _historyLog.car.site.unshift(list[i])
              }
            } else {
              _historyLog.car.site = [list[i]]
            }
            for( let j in this.carHistory){
              if( (item.location == list[i].name) && (item.location == this.carHistory[j].location)){
                let isShow = true // 当满足条件时结束循环
                let cityInfo = {}
                let siteCityId ={siteCityId:''}
                let geo = localget('geo_10906_zh-CN') || JSON.parse(localStorage.getItem('geo_10901_zh-CN'))
                for(let i in geo){
                  for(let j of geo[i]){
                    if(item.city == j.cityName){
                      cityInfo = j
                      siteCityId.siteCityId = j.cityId
                      isShow = false
                      break
                    }
                  }
                  if(isShow == false){
                    break
                  }
                }
                Object.assign(list[i],cityInfo,siteCityId)
                this.$emit('selected', list[i])
                break
              }
            }

          }

          localset('_historyLog', _historyLog)
          this.back()
          return
        })
      }
    },
    onSearch(keyword) {
      this.initData()
      this.model.keywords = keyword
      this.model._keywords = keyword
      this.back()
    },
    searchQueryText(queryText) {
      if (this.isCar) {
        if(this.model._city == '定位中...' || this.model._city == ''){
          if(this.cityName != ''){
            return new Promise((resolve, reject) => {
              this.$api['baidu/baiduPlace']({
                cityName: this.cityName || this.model._city,
                keywords: queryText
              })
                .then(res => {
                  res.data && resolve(res.data)
                })
                .catch(res => {
                  reject(res)
                })
            })
          } else{
            setTimeout(() => {
              this.model._keywords = ''
            }, 2000);
            Toast.fail('请选择城市')
            return
          }
        }
      }
      
      return new Promise((resolve, reject) => {
        this.$api[
          this.model._international == 0
            ? 'htQuery/keyword'
            : 'htQueryInt/keyword'
        ]({
          cityId: this.cityId || this.model.cityId, // 城市id
          queryText: queryText, // 关键字
          gngj: this.model._international == 0 ? '1' : '0', // 国内国际 1：国内 0：国际
          mappingInterfacePlatId: this.model.platZhid,
          interfacePlatId: this.interfacePlat.interfacePlatId,
          cityName: this.cityName || this.model._city,
        })
          .then(res => {
            res.data && resolve(res.data)
          })
          .catch(res => {
            reject(res)
          })
      })
    },
    changeCity(val) {
      this.cityName = val.cityName
      this.cityId = val.id || val.cityId
      this.jcZdCode=val.jcZdCode || val.threeCode
      this.$api['baidu/baiduPlace']({
        cityName: this.cityName,
        keywords: this.cityName
      }).then(res => {
        let cache = res.data || {}
        let list = cache.list || []
        if (list && list.length > 0) {
          list.splice(0, 1)
        }
        this.list = list
      })
    },
    clearSearch() {
      //清空搜索 还原默认
      this.model.searchType = 0
      this.model.keywords = ''
      this.model._keywords = ''
      this.model.businessZone = ''
      this.model.businessZoneName = ''
      this.model.district = ''
      this.model.districtName = ''
      this.model.lat = ''
      this.model.lon = ''
      this.model.brandIds = ''
    },
    removeItems() {
      if (this.isCar) {
        this.carHistory = []
        let _historyLog = localget('_historyLog')
        if (!_historyLog) {
          _historyLog = {}
        }
        if (!_historyLog.car) {
          _historyLog.car = {}
        }
        if (_historyLog.car.site) {
          _historyLog.car.site = []
          localset('_historyLog', _historyLog)
        }
      } else {
        localremove('_historicalRecord')
        this.historicalRecord = []
      }
    },
    toggle(name) {
      if (this.isCar) {
        this.$refs[name].toggle({ cityType: 4 })
      } else {
        this.$refs[name].toggle({ cityType: 1 })
      }
    },
    back() {
      if (this.isCar) {
        //用车
        this.model._keywords = ''
        this.$emit('callBack', false)
      } else {
        this.$router.go(-1)
      }
    }
  },
  watch: {
    'model._keywords'(queryText) {
      if (!queryText) {
        this.items = []
      } else {
        this.searchQueryText(queryText).then(item => {
          if (item.list) {
            this.items = item.list
          } else {
            this.items = item
          }
        })
      }
    },
    // cityId() {
    // 	this.init()
    // },
    carType(){
      this.init()
    }
  }
}
